import { render, staticRenderFns } from "./ReportNotification.vue?vue&type=template&id=19dd9d78&"
import script from "./ReportNotification.vue?vue&type=script&lang=ts&"
export * from "./ReportNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports